import { FormControl } from 'foundations-components/transitional/components/FormControl';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { List } from 'immutable';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// Extract the UTC offset from the label (e.g. "UTC 01:00 City Name" -> "01:00")
export const utcOffsetRegex = /([-]?\d{2}:\d{2})/;
const FilterOperatorTimeZoneEnumInput = ({
  disabled,
  error,
  onChange,
  readOnly,
  field,
  value,
  inputUse
}) => {
  const options = useMemo(() => {
    var _field$options;
    const allZoneOptions = (_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.toArray();
    if (!allZoneOptions) {
      return [];
    }
    const optionsByOffset = {};
    allZoneOptions.forEach(option => {
      const utcOffset = option.label.match(utcOffsetRegex);
      if (utcOffset) {
        const offset = utcOffset[0];
        if (!optionsByOffset[offset]) {
          optionsByOffset[offset] = [];
        }
        // formatted options
        optionsByOffset[offset].push({
          text: option.label,
          value: option.value
        });
      }
    });
    return Object.keys(optionsByOffset).map(key => {
      // formatted option groups
      return {
        text: I18n.text(`customerDataFiltersUI.customerDataFilters.FilterOperatorTimeZoneEnumInput.groupLabel`, {
          offset: key
        }),
        value: key,
        options: optionsByOffset[key],
        selectAll: true
      };
    });
  }, [field]);
  const valueAsArray = useMemo(() => {
    return value === null || value === void 0 ? void 0 : value.toArray();
  }, [value]);
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: error.get('error'),
    validationMessage: error.get('error') ? error.get('message') : null,
    children: /*#__PURE__*/_jsx(UISelect, {
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
      className: "ui-addon-team-uiselect",
      anchorType: "button",
      disabled: disabled,
      readOnly: readOnly,
      multi: true,
      onChange: evt => {
        onChange(syntheticEvent(List(evt.target.value)));
      },
      options: options,
      value: valueAsArray
    })
  });
};
export default FilterOperatorTimeZoneEnumInput;